<template>
  <div style="min-height: 100vh;" class="wrapper c-inherit-background" data-app>
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="desktop">
      <v-container
        style="position: relative"
        v-loading="loadingPage"
        class="p-12"
      >
        <div style="width: 100%; margin-top: 100px;">
          <div
            style="width: 100%; background-color: #FFFFFF; border-radius: 20px; padding: 20px"
          >
            <span style="font-weight: 600; font-size: 18px">{{
              $t("invoiceInformation")
            }}</span>
            <v-row class="grey" style="margin-top: 5px">
              <v-col cols="6">
                <info-bill :bill-detail="billDetail" />
              </v-col>
              <v-col cols="6">
                <div
                  style="box-shadow: 0px 0px 10px 0px rgba(129,129,129,0.15); border-radius: 10px"
                >
                  <div class="box-header_title">
                    <span>{{ $t("service") }}</span>
                    <span>{{ $t("totalAmount") }}</span>
                  </div>
                  <data-services :services="billDetail?.services || []" />
                </div>
              </v-col>
            </v-row>
            <div class="payment-details1">
              <div
                v-if="$route.query.status == 3 && billDetail?.payment_code"
                class="ml-10 mr-10 mb-10"
              >
                <CheckBoxPolicy @on-action="val => (this.checkedPay = val)" />
              </div>
              <info-payment
                :is-disabled="!checkedPay"
                :bill-detail="billDetail"
                :loading-submit="loadingSubmit"
                @on-action-payment="handlePayment"
              />
            </div>
          </div>
        </div>
      </v-container>
    </div>
    <div class="mobile header-top">
      <v-container style="position: relative" class="p-10">
        <v-row key="1" class="grey">
          <v-col cols="12" :md="9" :xs="24" :sm="24">
            <span style="font-size: 14px; font-weight: 600">
              {{ $t("invoiceInformation") }}
            </span>
            <info-bill style="margin-top: 15px" :bill-detail="billDetail" />
          </v-col>
          <v-col cols="12" :md="9" :xs="24" :sm="24">
            <template
              class="mx-auto component mt-10"
              style="box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15); "
            >
              <div class="box-header_title">
                <span>{{ $t("service") }}</span>
                <span>{{ $t("totalAmount") }}</span>
              </div>
              <data-services :services="billDetail?.services || []" />
            </template>
          </v-col>
        </v-row>
      </v-container>
      <div class="payment-details">
        <div v-if="$route.query.status == 3 && billDetail?.payment_code">
          <el-divider class="divider"></el-divider>
          <div class="ml-10 mr-10 mb-10">
            <CheckBoxPolicy @on-action="val => (this.checkedPay = val)" />
          </div>
        </div>
        <el-divider class="divider"></el-divider>

        <info-payment
          :is-disabled="!checkedPay"
          :bill-detail="billDetail"
          :loading-submit="loadingSubmit"
          @on-action-payment="handlePayment"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MainNavBarWapV2 from "../../../../layout/WapV2/MainNavBar.vue";

import { formatNumber, sumCollection } from "@/plugins/init";
import { dataTeeTime, teeTime } from "@/data-demo/init";
import { formatDate } from "@/utils/formatData";
import { decodeToken, getToken } from "@/utils/auth";
import { getBackGround } from "@/utils/wapAuth";
import GlobalAPI from "@/views/api/wap/global";
import { setInfoBooked } from "@/utils/booked";
import DataServices from "@/views/pages/wapV2/history/components/DataServices.vue";
import InfoBill from "@/views/pages/wapV2/history/components/InfoBill.vue";
import InfoPayment from "@/views/pages/wapV2/history/components/InfoPayment.vue";
import CheckBoxPolicy from "@/components/wapV2/CheckBoxPolicy.vue";
import dayjs from "dayjs";
import { SOURCE_BANK } from "@/constant/contant";
import TeeTimeResource from "@/views/api/wap/detail-tee-time";
import { toggleChat } from "@/utils/helper";

const SERVICE_ID_BIDV = "WG1001";

export default {
  components: {
    MainNavBarWapV2,
    DataServices,
    InfoBill,
    CheckBoxPolicy,
    InfoPayment
  },
  bodyClass: "detail-booked-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/svg/img-detail-booked-default.svg")
    },

    objDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loadingSubmit: false,
      bg: getBackGround(),
      infoHeader: {
        title: this.$t("invoiceInformation"),
        isShowHomeIcon: true,
        path: `/wap/history?type=${this.$route.query.type}`
      },
      checkedPay: true,
      checked: false,
      large: "large",
      isShow: [],
      shouldShowButton: false,
      dataTeeTime: dataTeeTime,
      facilityInfo: {},
      teeTime: teeTime,
      billDetail: null,
      icons: {},
      showServiceIcon: false,
      images: {},
      cardList: [
        { value: 1, label_title: "D100", label_content: "", money: 100000 },
        { value: 2, label_title: "D200", label_content: "", money: 200000 },
        { value: 3, label_title: "D50", label_content: "", money: 50000 },
        { value: 4, label_title: "D20", label_content: "", money: 20000 }
      ],
      form: {},
      tab: 0,
      pax: {
        teeTime: [],
        golfer: [],
        type_hio: 0,
        hio_all: ""
      },
      isShowContent: false,
      more: "Xem thêm",
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      isMobile: window.innerWidth < 768,
      loadingPage: false
    };
  },
  created() {
    if (this.$route.query?.facility_id === "undefined") {
      this.$router.back();
    }
  },

  watch: {
    windowWidth(width) {
      this.$vuetify.breakpoint.width < 768
        ? (this.isMobile = true)
        : (this.isMobile = false);
    },
    "pax.hio_all"(val) {
      if (val) {
        this.pax.golfer.forEach(golfer => {
          if (!golfer.hio_list.includes(val)) {
            golfer.hio_list = [...new Set([...golfer.hio_list, val])];
            golfer.money_with_hio = golfer.money;
            golfer.money_with_hio += this.cardList
              .filter(item => golfer.hio_list?.includes(item.value))
              ?.reduce(
                (accumulator, currentValue) => accumulator + currentValue.money,
                0
              );
          }
        });
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {
    decodeToken,
    handlePayment() {
      if (getToken().bank_id == SOURCE_BANK.BIDV) {
        this.handlePayBidv();
        return;
      }
      //&payment_amount=${this.billDetail?.payment_amount}
      this.$router.push(
        `/wap/payment-method?id_general_bill=${this.$route.params?.id}`
      );
    },
    handlePayBidv() {
      this.loadingSubmit = true;
      TeeTimeResource.encryptDataInquireBidv({
        service_id: SERVICE_ID_BIDV,
        order_id: this.$route.params?.id
      })
        .then(res => {
          console.log("res.............", res);
          if (res.error_code == 0) {
            location.href = `/wap/payment-method/payment-bidv?data=${res.data.encryptData}`;
            console.log("res.............", res);
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loadingSubmit = false;
        });
    },
    toggleIsShow(index) {
      if (!this.isShow) {
        this.isShow = []; // Khởi tạo isShow là một mảng nếu chưa tồn tại
      }
      // Nếu không có giá trị isShow cho chỉ số index, khởi tạo là false
      if (!this.isShow[index]) {
        this.$set(this.isShow, index, false);
      }
      // Toggle giá trị của isShow tại chỉ số index
      this.$set(this.isShow, index, !this.isShow[index]);
    },
    async fetchBillDetail() {
      this.loadingPage = true;

      const response = await GlobalAPI.getDetailBill(this.$route.params.id);
      // Assuming response.data contains the bill detail
      this.billDetail = response.data;
      setInfoBooked({
        id_general_bill: this.$route.params.id,
        ...response.data
      });
      this.loadingPage = false;
    },

    formatNumber,

    onResize() {
      this.windowWidth = window.innerWidth;
    },
    formatDate,
    sumCollection,
    checkPaymentStatus() {
      const services = this.billDetail?.services;
      if (services) {
        services.forEach(item => {
          if (item.can_payment === 1 && item.num_payment === 0) {
            this.shouldShowButton = true;
          } else {
            this.shouldShowButton = false;
          }
        });
      }
    }
  },
  computed: {
    formattedDate() {
      return timestamp => {
        return dayjs(timestamp).format("dddd, D/MM/YYYY");
      };
    },
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  mounted() {
    this.checkPaymentStatus();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.fetchBillDetail();
    toggleChat(false);
  },

  beforeDestroy() {
    toggleChat(true);
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style lang="scss" scoped>
.stringee_iframe_wrapper {
  z-index: -1 !important;
}
.header-top {
  padding-top: 100px;
}

.box-header_title {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 5px 10px;
  background: v-bind("bg.c_box_header_tee") !important;
  display: flex;
  justify-content: space-between;
}
.box-content {
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: #fff !important;
  //box-shadow: 0px 0px 4px 0px #00000026;
  overflow-y: auto;
  //max-height: 490px;
  margin-bottom: 136px;
}
.box-header {
  display: flex;
  padding: 10px;
  align-items: center;
}

.checkbox {
  margin-left: 2px;
}

.title {
  font-size: 14px;
  font-weight: 600;
}

.details {
  background-color: #021944;
  padding: 10px;
  transition: 5s;
}

.avatar {
  margin-left: 10px;
  width: 43px;
}

.payment-details {
  width: 100%;
  background-color: #f5f5f5;
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  z-index: 9999;
}
.payment-details1 {
  width: 100%;
  background-color: #ffffff;
  //position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}

.divider {
  //position: absolute;
  left: 0;
  right: 0;
  margin: 0 0 10px 0;
}

.content {
  margin-right: 12px;
  margin-left: 12px;
}

.el-checkbox__inner {
  border-radius: 50% !important;
}

.el-checkbox_inner {
  border-radius: 20px !important;
}

.mobile {
  display: none;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .header-top {
    padding-top: 60px !important;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>

<style lang="scss">
@media screen and (min-width: 0px) and (max-width: 769px) {
}
.component {
  border-radius: 8px;
  background: white;
  border: 1px solid gray;
  padding: 10px;
}

.mt-0 {
  margin-top: 0 !important;
}

.text-bold {
  font-weight: bold !important;
}
.color-price {
  // color: v-bind("bg.c_button_text");
  color: #fb7800;
}
.align-center {
  align-items: center !important;
}

.text-button {
  text-transform: unset !important;
  //font-weight: 300 !important;
  font-size: 8px !important;
}

.d-flex {
  display: flex;
}

.justify-space-between {
  justify-content: space-between !important;
}

.pointer {
  cursor: pointer;
}

.border-1 {
  border: 1px solid #ababab;
  border-radius: 10px;
}

.icon-image {
  height: 30px !important;
}

.text-not-break {
  word-break: keep-all !important;
}
</style>
